import * as React from 'react';
import { FieldArray } from 'redux-form';

import { SegmentLabel } from '@acceligentllc/storybook';

import Permits from './Permits';
import WorkRequestUpsertFM from '../../../formModel';
import { formSectionClass } from '../../../helpers';

const PermitsRequiredSection: React.FC = () => {
	return (
		<div className={formSectionClass}>
			<SegmentLabel
				label="Permits Required"
				tooltip="All permits and authorizations necessary for the legal execution of this job."
			/>
			<div className="m-b-m" />
			<FieldArray<void>
				component={Permits}
				name={WorkRequestUpsertFM.getAttributeName('permitsRequired')}
			/>
		</div>
	);
};

export default PermitsRequiredSection;
